import React from "react";
import styles from "./meetings.module.scss";
import Avatar from "components/minor/avatar/avatar";

const TranscriptItem = ({ name, time, text, avatar }) => {
  return (
    <div className={styles.transcriptItem}>
        {avatar} 
      <div className={styles.content}>
        <div className={styles.header}>
          <span className={styles.name}>{name}</span>
          <span className={styles.time}>{time}</span>
        </div>
        <div className={styles.text}>{capitalizeAfterPeriod(text)}</div>
      </div>
    </div>
  );
};
function capitalizeAfterPeriod(text = "") {
  if (!text) return "";

  return text
    .split(".")
    .map(sentence => sentence.trim())
    .filter(sentence => sentence.length > 0)
    .map(sentence => sentence.charAt(0).toUpperCase() + sentence.slice(1))
    .join(". ") + (text.endsWith(".") ? "." : "");
}

export default function TranscriptPage({transcript, interviewer,candidate}) {
  const hasTranscript =
  transcript && Object.keys(transcript).length > 0;
if (!hasTranscript) {
  return <div className={styles.empty}>No transcript available</div>;
}

  return (
    <div>
      {Object.values(transcript).map((t,index) => (
        <>
             <TranscriptItem
            name={interviewer}
            time={t.time}
            text={t.questions}
            avatar={<Avatar name={interviewer} size={32} fontSize={12} />}
          />
          <TranscriptItem
            name={candidate}
            time={t.time}
            text={t.answers}
            avatar={<Avatar name={candidate} size={32} fontSize={12} />}
          />
          </>
      ))}
    </div>
  );
}
